import { v1 } from './common/clients';

export default {
  getAll: () => v1.get('/profile/notices'),
  countUnread: () => v1.get('/profile/notices/count'),
  markRead: () => v1.put('/profile/notices')
};
